import { useTranslation } from "react-i18next";
import MailRowSkeleton from "./MailRowSkeleton";

type EmailListSkeletonProps = {
    count?: number;
    squeeze?: boolean;
};

const EmailListSkeleton = ({
    count = 8,
    squeeze = false,
}: EmailListSkeletonProps) => {
    const { t } = useTranslation();

    return (
        <div
            aria-busy="true"
            aria-label={t("emails.loading")}
            className="mb-4 flex w-full flex-col gap-1.5"
        >
            {Array.from({ length: count }, (_, index) => (
                <MailRowSkeleton key={index} squeeze={squeeze} />
            ))}
        </div>
    );
};

export default EmailListSkeleton;
